
export default {
  name: 'MyMap',
  props: {
    position: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pingVal: {
      type: String,
      default: ''
    },
    mtVal: {
      type: [String, Number],
      default: null
    },
     velocityVal: {
      type: [String, Number],
      default: null
    },
    
    detail: {
      type: Object,
      default: () => {
        return {}
      }
    },
    icon: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isShowMap: {
      type: Boolean,
      default: false
    },
    zoom: {
      type: Number,
      default: 15
    },
    currentPosition: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isFirstInit: true,
      map: null,
      BMap: null
    }
  },
  watch: {
    position: {
      handler() {
          // this.$refs.customOverlay.reload()
      },
      deep: true
    },
    isShowMap: {
      handler(odlV) {
        if (odlV) {
          this.setSourceCenter()
        }
      },
      deep: true
    }
  },
  mounted() {},
  methods: {
    showMap() {
      this.$emit('showMap')
    },
    offBaiduWindow() {
      this.$emit('offBaiduWindow')
    },
    openBDWidnow() {
      this.$emit('openBDWidnow')
    },
    // ar 语言 日期转换
    isArDate(str) {
      if (this.$store.state.LanguageCode == 'ar') {
        str = str.split('-').reverse().join('-')
      }
      return str
    },
    handleMap({ el, BMap, map }) {
      // const { lng, lat } = this.position
      this.offBaiduWindow()
      this.map = map
      this.BMap = BMap
      this.setSourceCenter()
      map.getPanes().markerPane.style.display = 'none';
    },
    setSourceCenter() {
      window.scrollTo(0, 0)
      this.map.setZoom(this.zoom)
      const { lng, lat } = this.currentPosition
      const point = new this.BMap.Point(lng + 0.0028, lat + 0.004)
      setTimeout(() => {
        this.map.panTo(point) // 平移
      }, 200)
      setTimeout(() => {
        // this.openBDWidnow()
      }, 1000)
    },
    draw({ el, BMap, map }) {
      this.offBaiduWindow()
      const { lng, lat } = this.position
      const pixel = map.pointToOverlayPixel(new BMap.Point(lng, lat))
      el.style.left = pixel.x - 50 + 'px'
      el.style.top = pixel.y - 50 + 'px'
      // if (this.detail?.isexhibition) {
      //   el.style.top = pixel.y - 235 * 1.52 + 'px'
      // } else {
      //   el.style.top = pixel.y - 220 * 1.45 + 'px'
      // }
    },
    pingIcon(i) {
				if (i == 1) return 'https://resources1.interface003.com/web20/img/commen/green.gif'
				else if (i == 2) return 'https://resources1.interface003.com/web20/img/commen/yellow.gif'
				else if (i == 3) return 'https://resources1.interface003.com/web20/img/commen/red.gif'
				else return 'https://resources1.interface003.com/web20/img/commen/red.gif'
			},
  }
}
